var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.8946 51C36.1031 51 46 40.951 46 28.555C46 16.1589 36.1031 6.10992 23.8946 6.10992C11.6861 6.10992 1.78912 16.1589 1.78912 28.555C1.78912 40.951 11.6861 51 23.8946 51Z",
    fill: "#6C63FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8168 0L0.0974731 18.1319L21.8813 44.2355L36.4029 26.8995L14.8168 0Z",
    fill: "#6C63FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.8168 0L0.0974731 18.1319L21.8813 44.2355L36.4029 26.8995L14.8168 0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.686401 18.3312C1.0122 17.7361 1.41596 17.189 1.88656 16.7041L15.4043 2.78919C15.4043 2.78919 20.1145 1.99187 21.096 4.38383L3.82742 18.7299L0.686401 18.3312Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.0329L20.017 49.1169C20.017 49.1169 21.9788 50.5123 23.9419 49.7149L44.449 35.6672L22.6665 2.19119L3.04216 17.7346L0 18.0329Z",
    fill: "#6C63FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2185 7.04474L7.65771 16.2084L7.84294 16.4701L20.4037 7.30649L20.2185 7.04474Z",
    fill: "#3F3D56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49171 19.6377L7.22693 19.8155L23.7125 45.1225L23.9773 44.9446L7.49171 19.6377Z",
    fill: "#3F3D56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0555 35.7371L25.7131 45.7038L25.9013 45.9634L39.2436 35.9967L39.0555 35.7371Z",
    fill: "#3F3D56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6008 7.47821L22.3403 7.66235L39.4147 32.5704L39.6753 32.3863L22.6008 7.47821Z",
    fill: "#3F3D56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.326 2.59084L1.79785 17.0627L1.9306 17.2095L17.4587 2.73768L17.326 2.59084Z",
    fill: "#3F3D56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6211 2.71657L2.39105 17.2638L2.52097 17.4133L18.7511 2.86601L18.6211 2.71657Z",
    fill: "#3F3D56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6341 3.00528L2.78754 17.2646L2.91324 17.4177L19.7598 3.15838L19.6341 3.00528Z",
    fill: "#3F3D56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.66aa5fe3cbc3630c02fd81028681d75f.svg";
export { ForwardRef as ReactComponent };